export default {
  subtotal: 'Subtotal',
  tip: 'Propina',
  discount: 'Descuento',
  method_fee: 'Gastos de envío',
  service_fee: {
    title: 'Tarifa de servicio',
    description:
      'Esta pequeña tarifa de servicio nos ayuda a cubrir los costes de cada pedido — como enviarte actualizaciones por SMS, mantener nuestra plataforma de pedidos en línea y gestionar tarifas de transacción. Y no te preocupes: esta tarifa sigue siendo mucho menor que la de las apps de delivery. ¡Gracias por tu comprensión y por apoyarnos directamente!',
  },
  payment_method_upcharge_fee: {
    title: 'Tarifa de PayPal',
    description:
      'Cada vez que un cliente paga con PayPal, PayPal cobra entre un 6-7% de comisión. En 100€, perdemos 6-7€. Por ello, lamentablemente debemos añadir un recargo del 3,5% por usar PayPal. 🤯 Te rogamos que consideres usar alguno de los otros métodos de pago seguros y cifrados. ¡Te agradecemos mucho tu comprensión y apoyo! 🙏',
  },
  tax: 'Impuestos',
  total: 'Total',
  earned_points: 'Ganaste {{points}} puntos',
};
